<template>

</template>

<style lang="scss">
@import '@/assets/css/vars.scss';



body {
    cursor: default;
    font-family: 'SFProDisplay';
    @include color('black');
    @include text-t();
}


:root {
    --swiper-pagination-bullet-horizontal-gap: 8px;
    --swiper-pagination-bullet-inactive-opacity: 1;
    @include color('white', '--swiper-pagination-bullet-inactive-color');
    @include color('red', '--swiper-pagination-color');
    --swiper-navigation-size: 50px;

    @include media(max, lg) {
        @include color('grey2', '--swiper-pagination-bullet-inactive-color');
    } 
}


//Slider
.swiper-button-next,
.swiper-button-prev {
    &:after {
        content: "";
    }

    &--rounded {
        width: 50px;
        border-radius: 50%;
        @include color('grey1', 'background-color');
        transition: .35s background-color $trFun;

        &:hover {
            @include color('grey2', 'background-color');
        }

        &.icon {
            svg {
                width: 10px;
            }
        }
    }

    &--simple {
        margin-top: -12px;
        width: 25px;
        height: 25px;
        transition: .35s opacity $trFun;

        &:hover {
            opacity: 0.6 !important;
        }

        &:active {
            opacity: 1 !important;
        }
    }
}
.swiper-button-prev {
    &--rounded {
        left: 15px;
    }
    &--simple {
        left: 10px;
    }
}
.swiper-button-next {
    &--rounded {
        right: 15px;
    }
    &--simple {
        right: 10px;
    }
}
.swiper-pagination {
    font-size: 0;
    line-height: 0;

    .swiper-pagination-bullet {
    }

    &.swiper-pagination-horizontal {
        bottom: 20px;
    }

    @include media(max, lg) {
        position: static;
        padding: 10px 0;
    }
}


.chips {
    .chips-item {
        margin: 0 15px 15px 0;
        display: inline-block;
        border-radius: 50px;
        @include color('grey1', 'background-color');
        @include text-t_tiny;
        text-transform: uppercase;
        @include color('black');
        text-decoration: none;
        padding: 6px 20px;
        transition: .35s background-color $trFun;

        @include media(max, lg) {
            margin: 0 10px 10px 0;
        }

        &:hover {
            @include color('grey2', 'background-color');
        }

        &:active {
            @include color('grey1', 'background-color');
        }
    }
}

.search-form {
    .search-form-field {
        display: block;
        width: 100%;
        font-family: 'SFProDisplay';
        @include text-t_tiny;
        text-transform: uppercase;
        @include color('black');
        padding: 4px 0 18px 35px;
        background: url('~@/assets/sprite/svg/loupe.svg') no-repeat left 0;
        background-size: 25px 25px;
        border-bottom: 1px solid #{map-get($colors, 'grey3')};

        &::-webkit-search-cancel-button {
            -webkit-appearance: none;
            cursor: pointer;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            @include color('grey2', 'background-color');
            background-image: url('~@/assets/sprite/svg/close.svg');
            background-size: 15px 15px;
            background-position: center center;
            background-repeat: no-repeat;
            transition: .35s background-color $trFun;

            &:hover {
                @include color('grey1', 'background-color');
            }
        }
    }
}
.search-items {
    .search-item {
        img {
            transition: .35s opacity $trFun;
        }
        .search-item-title {
            @include text-t_tiny;
            text-transform: uppercase;
        }

        &:hover {
            img {
                opacity: 0.7;
            }
        }
    }
}


.share-items {
    .share-item {
        transition: .35s opacity $trFun;

        &:hover {
            opacity: 0.6;
        }

        &:active {
            opacity: 1;
        }
    }
}




// Popups
.is-popup {
    position: absolute;
    z-index: 5000;
    display: none;
    opacity: 0;
    transform: translateY(-10px);
    transition: .35s opacity $trFun, .35s transform $trFun;

    &.show {
        transform: translateY(0);
        opacity: 1;
    }
}
.one-filter
{
    .bordered-selector {
    width: 385px;
    max-width: 385px;
    padding: 3px 16px;
    border: 1px solid #{map-get($colors, 'grey2')};
    border-radius: 10px;

        @include media(max, md) {
            max-width: 100%;
            width:100%;
        }
    }
}

// //Popups



// Gallery
.page-popup-gallery {
    .fancybox-bg {
        background: #FFF;
    }

    .fancybox-toolbar {
        opacity: 1 !important;
        visibility: visible !important;
        display: flex;
        padding: 25px;

        button {
            cursor: pointer;
            margin-left: 20px;
            transition: .35s opacity $trFun;

            svg {
                display: block;
            }

            &:hover {
                opacity: 0.6;
            }
        }
    }

    .page-popup-gallery-nav {
        display: block;
        top: 50%;
        transform: translateY(-50%);
        width: 50px;
        height: 50px;
        position: absolute;
        z-index: 99999;
        cursor: pointer;
        overflow: hidden;
        border-radius: 50%;
        @include color('grey1', 'background-color');
        transition: .35s background-color $trFun;

        &:hover {
            @include color('grey2', 'background-color');
        }

        &--left {
            left: 20px;
        }

        &--right {
            right: 20px;
        }
    }

    &.fancybox-is-open {
        .fancybox-bg {
            opacity: 1;
        }
    }
}

@include media(max, md) {
    .fancybox-slide--video {
        padding: 20px;

        .fancybox-content {
            position: relative;
            height: 100% !important;
            width: 100% !important;
        }
    }
}


.orders, .filter-control
{
    display:none;
}

// Forms
.cities-popup {
    margin-left: 0;
    margin-top: 15px;
    @include color('white', 'background-color');
    width: 385px;
    border: 1px solid #{map-get($colors, 'grey2')};
}

.one-filter
{
    position:relative;
    height:46px;
    
}
.one-filter label
{
    display: flex !important;
    align-items: center;
    height:100%;
}
.one-filter:hover .filter-popup
{
    display:block;
}

.filter-popup {
    margin-left: 0;
    margin-top: 0px;
    @include color('white', 'background-color');
    width: 300px;
    border: 1px solid #{map-get($colors, 'grey2')};
    z-index:101;
    position:absolute;
    display: none;
   
}
.sorter-popup {
    margin-left: 0;
    margin-top: 15px;
    @include color('white', 'background-color');
    width: 250px;
    border: 1px solid #{map-get($colors, 'grey2')};
}
.form-label {
    cursor: pointer;
}
.form-checkbox {
    cursor: pointer;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -100%);
        display: block;
        opacity: 0;
        width: 13px;
        height: 9px;
        background: url('~@/assets/sprite/svg/form_check.svg') no-repeat center center;
        background-size: contain;
        transition: .35s opacity $trFun, .35s transform $trFun;
    }

    &:before {
        content: '';
        display: block;
        border: 1px solid #{map-get($colors, 'formBorder')};
        width: 19px;
        height: 19px;
        border-radius: 2px;
        transition: .35s border-color $trFun, .35s background-color $trFun;
    }

    &:hover {
        &:before {
            @include color('formActiveBorder', 'border-color');
        }
    }

    &:checked {
        &:before {
            @include color('black', 'border-color');
            @include color('black', 'background-color');
        }
        &:after {
            opacity: 1;
            transform: translate(-50%, -50%);
        }
    }
}
.form-text,
.form-textarea,
.form-select {
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-family: 'SFProDisplay';
    font-size: 14px;
    line-height: 20px;
    @include color('black');
    @include color('white', 'background-color');
    border-radius: 10px;
    border: 1px solid #{map-get($colors, 'formBorder')};
    transition: .35s border-color $trFun;

    &::placeholder {
        @include color('grey');
        transition: .35s opacity $trFun;
    }

    &:focus {
        &::placeholder {
            opacity: 0;
        }
    }

    &:hover,
    &:focus {
        @include color('formActiveBorder', 'border-color');
    }
}
.form-text {
    padding: 6px 16px;
}
.form-textarea {
    padding: 12px 20px;
    min-height: 80px;
}
.form-select {
    padding: 6px 16px;
    appearance: none;
    cursor: pointer;
    background: url('~@/assets/sprite/svg/select_arr.svg') no-repeat calc(100% - 10px) center;

}
.form-file {
    position: relative;
    cursor: pointer;

    input[type='file'] {
        opacity: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: pointer;
    }

    &:hover {
        .btn--black_border {
            @include color('grey2', 'background-color');
        }
    }
}
.form-result {
    padding: 10px 55px;
    @include color('grey1', 'background-color');
}
// //Forms



.project-item {
    position: relative;
    display: block;

    .project-item-badge {
        position: absolute;
        top: 20px;
        @include color('grey1', 'background-color');
        border-radius: 10px;
        min-width: 43px;
        text-align: center;
        z-index: 100;
        padding: 2px 10px;

        @include media(max, lg) {
            top: 15px;
        }

        &--right {
            right: 20px;

            @include media(max, lg) {
                right: 15px;
            }
        }

        &--left {
            left: 20px;

            @include media(max, lg) {
                left: 15px;
            }
        }
    }

    .project-item-video {
        position: absolute;
        z-index: 20;
        left: 20px;
        bottom: 20px;
        width: 40px;
        height: 40px;

        @include media(max, lg) {
            left: 15px;
            bottom: 42px;
        }
    }

    .swiper-button-prev,
    .swiper-button-next {
        opacity: 0;
        pointer-events: none;
        transition: .35s all $trFun;
    }

    @media (hover: hover) {
        &:hover {
            .swiper-button-prev,
            .swiper-button-next {
                opacity: 1;
                pointer-events: all;
            }
        }
    }
}


.expand-item:not(.mb-10)
{
    margin-bottom: -1px;
}

.expand-item {
    
    border-top: 1px solid #{map-get($colors, 'grey2')};
    border-bottom: 1px solid #{map-get($colors, 'grey2')};

    .expand-item-heading {
        position: relative;
        padding-right: 50px;
        cursor: pointer;
        transition: .35s opacity $trFun;
        
        @include media(max, lg) {
            padding-right: 35px;
        }

        &:after,
        &:before {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            display: block;
            width: 25px;
            height: 25px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center center;
            transition: .35s opacity $trFun;
        }

        &:before {
            background-image: url('~@/assets/sprite/svg/icon_plus.svg');
        }

        &:after {
            background-image: url('~@/assets/sprite/svg/icon_minus.svg');
            opacity: 0;
        }

        @media (hover: hover) {
            &:hover {
                opacity: 0.6;
            }
        }
    }

    .expand-item-content {
        display: none;
    }

    &.open {
        .expand-item-heading {
            &::before {
                opacity: 0;
            }
            &::after {
                opacity: 1;
            }
        }

        .expand-item-content {
            display: block;
        }
    }
}

.mobile-filter {
    .expand-item {
        @include color('black', 'border-top-color');
        @include color('black', 'border-bottom-color');
    }
}


.salon-map {
    ymaps[class*='ground-pane'] {
        filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }
}


.mobile-scroll {
    
        width: 100%;
        // display: inline-block !important;
        white-space: nowrap;
        overflow: auto;
        padding-bottom: 10px;
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        margin: 0 !important;
    

    .mobile-scroll-item {
        
            padding: 0 !important;
            margin: 0 10px 0 0 !important;
            width: 230px;
            display: inline-block !important;
            white-space: normal;
            vertical-align: top;

            &:last-child {
                margin-right: 0 !important;
            }

            .project-item-video {
                bottom: 15px;
            }
        
    }
}


.page-top {
    position: fixed;
    right: 40px;
    bottom: 200px;
    z-index: 500;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #999999;
    border-radius: 50%;
    background-color: map-get($colors, 'white');
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transition: .35s background-color $trFun, .35s border-color $trFun, .35s opacity $trFun;

    &.show {
        pointer-events: all;
        opacity: 1;
    }

    @include media(max, lg) {
        bottom: 100px;
    }

    .icon {
        width: 24px;
        height: 24px;
    }

    &:hover {
        background-color: map-get($colors, 'black');
        border-color: map-get($colors, 'black');
    }
}
</style>

<script>
//import PageNav from '@/components/Nav.vue'
export default {
    name: 'PageHeader',
    //components: {PageNav},
    mounted() {

    }
}
</script>
